import { render } from "./MenuSecundario.vue?vue&type=template&id=fe324eca&scoped=true"
import script from "./MenuSecundario.vue?vue&type=script&lang=js"
export * from "./MenuSecundario.vue?vue&type=script&lang=js"

import "./MenuSecundario.vue?vue&type=style&index=0&id=fe324eca&scoped=true&lang=css"
import "./MenuSecundario.vue?vue&type=style&index=1&id=fe324eca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe324eca"]])

export default __exports__